// src/services/api/helpers.js
// Shared infrastructure used by all domain API modules.

import { fetchWithCommonHeaders } from "../fetchHelper";
import { startNetworkActivity, endNetworkActivity } from '../../utils/NetworkActivityManager';
import { API_URL } from '../../config/api';

// Re-export so domain modules can import from one place
export { fetchWithCommonHeaders, startNetworkActivity, endNetworkActivity, API_URL };

// Global auth error handler
let globalAuthErrorHandler = null;

export function setGlobalAuthErrorHandler(handler) {
    globalAuthErrorHandler = handler;
}

export function getGlobalAuthErrorHandler() {
    return globalAuthErrorHandler;
}

// Special error for authorization
export class AuthError extends Error {
    constructor(message) {
        super(message);
        this.name = 'AuthError';
    }
}

// Wrapper for token and authorization error checking
export async function withAuthCheck(fetchFn, ...args) {
    const token = args[0];
    if (!token) {
        throw new AuthError('Authorization required');
    }
    try {
        return await fetchFn(...args);
    } catch (err) {
        if (err.response && err.response.status === 401) {
            throw new AuthError('Authorization error');
        }
        if (err.name === 'AuthError') {
            throw err;
        }
        throw err;
    }
}
